import React, { useEffect, useRef, useState } from 'react';

function ImageWithLoader({
    src,
    alt,
    className = '',
    wrapperClassName = '',
    loaderClassName = '',
    spinnerSize = '2.8rem',
    spinnerSpeed = '.9s',
    spinnerColor = '#183153',
    loading = 'lazy'
}) {
    const [isLoading, setIsLoading] = useState(true);
    const [hasError, setHasError] = useState(false);
    const imageRef = useRef(null);

    useEffect(() => {
        setIsLoading(true);
        setHasError(false);

        const imageElement = imageRef.current;
        if (!imageElement) {
            return;
        }

        if (imageElement.complete) {
            const loadedSuccessfully = imageElement.naturalWidth > 0;
            setIsLoading(false);
            setHasError(!loadedSuccessfully);
        }
    }, [src]);

    return (
        <div className={`relative ${wrapperClassName}`}>
            {isLoading && (
                <div
                    className={`absolute inset-0 flex items-center justify-center rounded-[inherit] bg-[rgba(244,245,247,0.55)] ${loaderClassName}`}
                    aria-hidden
                />
            )}

            {isLoading && (
                <div className="pointer-events-none absolute inset-0 flex items-center justify-center" aria-hidden>
                    <div
                        className="dot-spinner"
                        style={{
                            '--uib-size': spinnerSize,
                            '--uib-speed': spinnerSpeed,
                            '--uib-color': spinnerColor
                        }}
                    >
                        <div className="dot-spinner__dot" />
                        <div className="dot-spinner__dot" />
                        <div className="dot-spinner__dot" />
                        <div className="dot-spinner__dot" />
                        <div className="dot-spinner__dot" />
                        <div className="dot-spinner__dot" />
                        <div className="dot-spinner__dot" />
                        <div className="dot-spinner__dot" />
                    </div>
                </div>
            )}

            {hasError ? (
                <div
                    className={`${className} flex items-center justify-center rounded-[inherit] bg-[#e5eaf1] text-xs font-medium text-[#6a7887]`}
                >
                    Image unavailable
                </div>
            ) : (
                <img
                    ref={imageRef}
                    src={src}
                    alt={alt}
                    loading={loading}
                    decoding="async"
                    onLoad={() => setIsLoading(false)}
                    onError={() => {
                        setIsLoading(false);
                        setHasError(true);
                    }}
                    className={`${className} transition-opacity duration-300 ${
                        isLoading ? 'opacity-0' : 'opacity-100'
                    }`}
                />
            )}
        </div>
    );
}

export default ImageWithLoader;
